d<template>
  <div>
    <search-filters></search-filters>
    <search-results></search-results>
  </div>
</template>

<script>
  import SearchFilters from './Filters'
  import SearchResults from './Results'

  export default {
    name: "AdminLotsSearch",

    components: {
      SearchFilters,
      SearchResults
    }
  }
</script>

<style scoped>

</style>
